export enum ThemeActionTypes {
  IS_DARK_MODE = 'IS_DARK_MODE',
}

interface ISwitchThemeAction {
  type: ThemeActionTypes.IS_DARK_MODE;
  payload: boolean;
}

export type TThemeActions = ISwitchThemeAction;

export const switchTheme = (payload: boolean): TThemeActions => ({
  type: ThemeActionTypes.IS_DARK_MODE,
  payload,
});
